<template>
  <v-layout>
    <v-flex>
      <div class="text-right mb-6">

        <v-btn
          class="ml-md-10"
          dark
          large
          depressed
          color="primary"
          :to="{ name:'delivery', params: { id: 'add' } }"
        >
          <v-icon dark class="mr-2">
            mdi-plus
          </v-icon>
          <span class="mx-4">Create New Dispatch Order</span>
        </v-btn>
      </div>
      <v-card class="pa-6 pt-4 mt-10">
        <v-card-title>
          Dispatch Orders
          <v-spacer></v-spacer>
          <v-select
            v-model="status"
            :items="statuses"
            @change="filterBy"
            menu-props="auto"
            label="Status"
            item-text="name"
            class="max-width-300 mr-10"
            prepend-icon="mdi-filter-outline"
            item-value="id"
            hide-details
          >
          </v-select>
          <v-text-field
            v-model="search"
            class="table-search"
            append-icon="mdi-magnify"
            label="Search"
            hide-details>
          </v-text-field>
        </v-card-title>

        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="deliveries"
          :server-items-length="pagination.total"
          :items-per-page="pagination.per_page"
          :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
          :loading="loading"
          loading-text="Loading Dispatch Orders..."
          item-key="id"
          no-data-text="No Dispatch Orders Found"
          :options.sync="options"
          ref="table">

          <template v-slot:[`item.delivery_no`]="{ item }">
            <div class="d-flex align-center">
              <v-icon
                size="24"
                class="mr-1">
                mdi-truck-fast-outline
              </v-icon>
              {{ item.delivery_no }}
            </div>
          </template>

          <template v-slot:[`item.deliver_to_name`]="{ item }">
            <div class="d-flex align-center">
              <v-icon
                size="24"
                class="mr-1">
                mdi-account-outline
              </v-icon>
              {{ item.deliver_to_name }}
            </div>
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <DeliveryStatus :status="item.status" :small="true" :statuses="statuses"></DeliveryStatus>
          </template>

          <template v-slot:[`item.delivery_date`]="{ item }">
            {{ item.delivery_date | moment("MMM D, YYYY") }}
          </template>

          <template v-slot:[`item.created_at`]="{ item }">
            {{ item.created_at | moment("MMM D, YYYY h:mm A") }}
          </template>

          <template v-slot:[`item.updated_at`]="{ item }">
            {{ item.updated_at | moment("MMM D, YYYY h:mm A") }}
          </template>

          <template v-slot:item.action="{ item }">

            <v-menu
              transition="slide-y-transition"
              offset-y
              bottom
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn

                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item link @click="delivered(item)" v-if="item.status == $getConstDeliveryStatus('DELIVERY_STATUS_CREATED')">
                  <v-list-item-title><v-icon class="mr-4">
                      mdi-receipt-text-check-outline
                    </v-icon>
                    Order Complete
                  </v-list-item-title>
                </v-list-item>
                <v-list-item link @click="viewItem(item.id)">
                  <v-list-item-title><v-icon class="mr-4">
                      mdi-file-document-outline
                    </v-icon>
                    View
                  </v-list-item-title>
                </v-list-item>
                <v-list-item link @click="editItem(item.id)" v-if="item.status == $getConstDeliveryStatus('DELIVERY_STATUS_CREATED')">
                  <v-list-item-title>
                    <v-icon class="mr-4">
                      mdi-receipt-text-edit-outline
                    </v-icon>
                    Edit
                  </v-list-item-title>
                </v-list-item>
                <v-list-item link @click="deleteItem(item)" v-if="item.status == $getConstDeliveryStatus('DELIVERY_STATUS_CREATED')">
                  <v-list-item-title>
                    <v-icon class="mr-4">
                      mdi-receipt-text-remove-outline
                    </v-icon>
                    Delete
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>




      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
      <ConfirmationDialog
        :dialog="dialog"
        @doConfirm="doConfirm"
        @doCancel="doCancel"
      >
      </ConfirmationDialog>
    </v-flex>
  </v-layout>

</template>

<script>
  import { mapGetters } from "vuex";
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import ConfirmationDialog from '@/components/dialog/ConfirmationDialog.vue'
  import DeliveryStatus from '@/components/DeliveryStatus.vue'

  export default {
    name: 'AgentBookingList',
    data() {
      return {
        operationsNamespace: 'operations',
        snackbarDetails: {
          color: 'sb-success',
          msg: '',
          show: false
        },
        dialog: {
          show: false,
          title: 'Delete Item',
          body: 'Are you sure you want to delete this item?',
          type: '',
          item: {},
          confirmBtn: 'Yes',
          cancelBtn: 'Cancel'
        },
        error:{
          show: false,
          status: '',
          error: '',
          messages: {}
        },
        firstLoad: true,
        loading: false,
        search: '',
        awaitingSearch: false,
        selected: [],
        status: '',
        statuses: [],
        deliveries: [],
        pagination: {
          page: 1,
          per_page: 1,
          total: 0,
          next: 0
        },
        options: {},
        headers: [
          {
            text: 'DO No.',
            align: 'start',
            value: 'delivery_no',
            sortable: false
          },
          {
            text: 'Shipping Mark',
            align: 'start',
            value: 'shipping_marks',
            sortable: false
          },
          {
            text: 'Container',
            align: 'start',
            value: 'containers',
            sortable: false
          },
          {
            text: 'DO Date',
            align: 'start',
            value: 'delivery_date',
            sortable: false
          },
          {
            text: 'Client Name',
            align: 'start',
            value: 'deliver_to_name',
            sortable: false
          },
          {
            text: 'Client Contact No',
            align: 'start',
            value: 'deliver_to_contact_no',
            sortable: false
          },
          {
            text: 'Created Date',
            align: 'start',
            value: 'created_at',
            width: 180,
            sortable: false
          },
          {
            text: 'Status',
            align: 'start',
            value: 'status',
            sortable: false,
            width: 90
          },
          {
            text: '',
            value: 'action',
            sortable: false,
            width: 50
          }
        ]
      }
    },
    computed: {
      ...mapGetters(['getUserInitial', 'formatNumber', 'formatNumberAmount']),
      hasSelected: function(){
        return this.selected.length != 0 ? false : true
      }
    },
    watch: {
      options: {
        handler () {
          this.getDeliveryOrders()
        },
        deep: true,
      },
      search: function (val) {
        if (!this.awaitingSearch) {
          setTimeout(() => {
            this.options.page = 1
            this.getDeliveryOrders()
            this.awaitingSearch = false;
          }, 1000); // 1 sec delay
        }
        this.awaitingSearch = true;
      },
    },
    methods: {
      filterBy (id) {
        this.status = id
        this.options.page = 1
        this.getDeliveryOrders()
      },
      delivered (item){
        this.dialog = {
          show: true,
          title: 'Order Complete',
          body: 'Are you sure the dispatch order '+item.delivery_no+' has been completed?',
          type: 'confirm-delivered',
          item: item,
          confirmBtn: 'Yes',
          cancelBtn: 'No'
        }
      },
      deliveryMade (){
        self.loading = true

        this.$http.secured.post(this.operationsNamespace+'/deliveries/delivered/'+this.dialog.item.id, '')
          .then(response => {
            this.showMessage("Dispatch order "+this.dialog.item.delivery_no+" has been successfully completed.", 'success')
            self.loading = false
            this.getDeliveryOrders()
          })
          .catch(error => {
            if (error.response) {
              this.showMessage(error.response.data.messages, 'error')
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })
      },
      editItem (id) {
        this.$router.push({ name: 'delivery', params: { id: id } })
      },
      itemRowBackground: function (item) {
         return item.sales_agent > 0 ? '' : 'bg-lightblue'
      },
      getAgentName: function(id){
        let agents = this.agents.filter(agent => {
          return agent.id == id
        })
        if(agents.length > 0){
          let agent = agents[0]
          return agent.first_name + ' ' + agent.last_name
        }
      },
      getStatusName: function(id){
        let statuses = this.statuses.filter(status => {
          return status.id == id
        })
        if(statuses.length > 0){
          return statuses[0].name
        }
      },
      getDefaultData () {
        let self = this
        this.$http.plain.get('/default-data?delivery_statuses=true')
          .then(response => {

            let allowedStatuses = [
              '',
              this.$getConstDeliveryStatus('DELIVERY_STATUS_CREATED'),
              this.$getConstDeliveryStatus('DELIVERY_STATUS_DELIVERED')
            ]

            response.data.delivery_statuses.forEach(obj => {
              if(allowedStatuses.includes(obj.id)) this.statuses.push(obj)
            })            
          })
          .catch(error => {
            console.log(error);
          })
      },
      doConfirm () {
        this.dialog.show = false
        if(this.dialog.type == 'confirm-delivered'){
          this.deliveryMade()
        }else{
          this.confirmDeleteItem()
        }
      },
      doCancel () {
        this.dialog.show = false
      },
      deleteItem (item) {
        this.dialog = {
         show: true,
         title: 'Delete Dispatch Order',
         body: 'Are you sure you want to delete '+item.delivery_no+' dispatch order?',
         type: 'close',
         item: item,
         confirmBtn: 'Yes',
         cancelBtn: 'No'
        }
      },
      confirmDeleteItem () {
        let self = this
        self.loading = true
        this.$http.secured.delete(this.operationsNamespace+'/deliveries/'+ this.dialog.item.id)
          .then(response => {
            self.showMessage(this.dialog.item.delivery_no + " has been successfully deleted", 'success')
            // if(self.options.page > 1) {
            //     self.options.page = 1
            //     return false
            // }
            self.loading = false
            self.getDeliveryOrders()
          })
          .catch(error => {
            if (error.response) {
              this.showMessage(error.response.data.error, 'error')
              this.error.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
            self.dialog.show = false
          })

      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      viewItem (id) {
        this.$router.push({ name: 'delivery-view', params: { id: id } })
      },
      getDeliveryOrders () {
        if (this.loading) {
          return false
        }

        const { sortBy, sortDesc, page, itemsPerPage } = this.options
        let sorting = []
        let params = []

        if (sortBy.length === 1 && sortDesc.length === 1) {
          sortBy.forEach(function (item, index) {
            let sort = 'ASC'
            if (!sortDesc[index]) {
              sort = 'DESC'
            }
            sorting.push(item+'='+sort)
          });
        }

        params = { page: page, per_page: itemsPerPage }
        if (this.search.length > 0) params.search = this.search
        if (this.status.length > 0) params.status = this.status

        if(!this.firstLoad){
          this.$router.push({ name: 'delivery-orders-page', params: { page: page }})
        }

        this.firstLoad = false

        this.loading = true
        let self = this
        this.$http.plain.get(this.operationsNamespace+'/deliveries', { params: params })
          .then(response => {
            this.deliveries = response.data.deliveries

            if (response.data.pagination) {
              let pagination = response.data.pagination

              this.pagination.total = pagination.count
            }

          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.loading = false
          })
        }
    },
    mounted() {
      if(this.$route.query.added){
        this.showMessage(this.$route.query.message, 'success')
        this.$router.push({ name: 'delivery-orders' })
      }

      if(this.$route.params.page){
        this.options.page = parseInt(this.$route.params.page)
      }

      this.getDefaultData()

    },
    components: {
      SnackBar,
      ConfirmationDialog,
      DeliveryStatus
    },
  }
</script>
